export default "__VITE_ASSET__Ska0emFH__"